import api from '..'

const mandatoryCoursesList = () => {
  return api.get('courses/mandatory').then(({ data }) => {
    return data.data.map(({ attributes }: any) => attributes)
  })
}

export default mandatoryCoursesList
